export const MIDIMetaEvents = {
  sequenceNumber: 0x00,
  text: 0x01,
  copyrightNotice: 0x02,
  trackName: 0x03,
  instrumentName: 0x04,
  lyrics: 0x05,
  marker: 0x06,
  cuePoint: 0x07,
  midiChannelPrefix: 0x20,
  portPrefix: 0x21,
  endOfTrack: 0x2f,
  setTempo: 0x51,
  smpteOffset: 0x54,
  timeSignature: 0x58,
  keySignature: 0x59,
  sequencerSpecific: 0x7f,
} as const
